export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/serviceWorker.js", { scope: "/", updateViaCache: "none" })
        .then(() => {
          console.error("Service Worker registered.");
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    });
  }
};
